import putFetcher from 'api/utils/putFetcher';
import { useCallback } from 'react';
import type { LegacyDeviceWebhook } from 'types/legacyDashboard';

interface UpdateWebhookProps {
  deviceId?: DeviceId;
}

interface UpdateWebhookReturn {
  data: LegacyDeviceWebhook;
  success: boolean;
}

const useUpdateWebhook = ({ deviceId }: UpdateWebhookProps) => {
  const url = `${process.env.VITE_API_ROOT}/devices/${deviceId}/webhook`;

  const callback = useCallback(
    async (port: number, protocol: string) => {
      const result: UpdateWebhookReturn | undefined = await putFetcher({
        url,
        body: {
          port,
          protocol,
        },
      });

      return result;
    },
    [url]
  );

  return callback;
};

export default useUpdateWebhook;
